import type { FaireProductEntity } from "../../entity_types/product";

export const p_5sn7s4fxym: FaireProductEntity = {
  token: "p_5sn7s4fxym",
  type: "product",
  name: "Little Dishes",
  brandToken: "b_eunb5c9cgs",
  brandName: "Down to Earth Pottery",
  imageUrl: "https://cdn.faire.com/fastly/e34f94351dacb2a95c1bcb75cf60bd05509650b81d93dad95e16a1300054e924.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/111ddf1c01e9f21ff9a13bbbbbfcb8ab9cde77b7961e786706fe3a9901d3d517.png",
    "https://cdn.faire.com/fastly/4830151d1bebe0e95cdae04fd68d8a56068576e4355435dede1220e54c0fea73.png",
    "https://cdn.faire.com/fastly/c90d48faaf41637c10cc8c8fe3ea25bfd9611c9bad9ddb4ae6c749b2dbe15c3c.png"
  ],
  priceDollars: 5,
  description: "Handmade in Colorado with all natural materials and recycled glass! What will you use your little dish for? Teabags, incense, rings-n-things, candles, loose change, pills ...and many other uses! Sold in an even assortment of all our different shapes and colors. No two are exactly a like! Crackled glass is not food safe.\n(Basket not included & dishes are roughly 3.5\" in diameter)\nCases are prepacked and shipped directly from Faire. No special requests can be made for this item.\n",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:36.663Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
